import * as base from './base.jsx';

export default class BaseFilter extends base.DismissComponent {
  constructor(props) {
    super(props);
    this.requestIndex = 0;
    this.loading = null;
    this.pageNumber = 0;
  }

  getDefaultState() {
    return {
      availableOptions: {},
      availableOptionKeys: []
    }
  }

  getThisFiltersDefaultsFromQuery() {
    var queryParams = URI(document.URL).query(true);
    if (queryParams && queryParams.filters) {
      var filtersQueryObj = JSON.parse(queryParams.filters);
      if (filtersQueryObj[this.props.filterKey]) {
        return filtersQueryObj[this.props.filterKey];
      }
    }

    return undefined;
  }

  componentWillMount() {
    var defaults = this.getThisFiltersDefaultsFromQuery();
    if (!defaults) {
      defaults = this.props.defaults || [];
    }
    var filters = URI(document.URL).query(true).filters;
    var newOptions = this.loadAvailableOptions(defaults);
    var keys = [];

    if (newOptions) {
      for (var key in newOptions) {
        keys.push(key);
        if (defaults.indexOf(key) >= 0) {
          newOptions[key].selected = true;
        }
      }

      this.setState({
        "availableOptions": newOptions,
        "availableOptionKeys": keys
      })
    }

    radio("filterShown").subscribe(this.filterShown.bind(this));
  }

  componentDidMount() {
    radio("filterInitialized").broadcast(this);
  }


  loadAvailableOptions(defaults) {
    if (this.options) {

    }
  }

  filterShown(data) {
    if (data.props.filterKey != this.props.filterKey) {
      this.setState({
        toggled: false
      });
    }
  }

  isSelected(key) {
    return this.state.availableOptions[key].selected;
  }

  getSelectedString() {
    if (this.getFilterColumns() > 1) {
      var selectedString = this.state.availableOptionKeys.map ( key => {
        var option = this.state.availableOptions[key];
        if (option.selected) {
          return option.shortTitle ? option.shortTitle : option.title;
        } else {
          return null;
        }
      }).filter(Boolean).join(", ");

      return selectedString ? selectedString : this.props.emptySelectedString;
    } else {
      return " "
    }
  }

  isNoneSelected() {
    for (var i = 0; i < this.state.availableOptionKeys.length; i++) {
      var key = this.state.availableOptionKeys[i];
      if (this.state.availableOptions[key].selected) {
        return false;
      }
    }

    return true;
  }

  optionSelectionChanged(key) {
    this.setState(currentState => {
      if (this.state.multiSelectEnabled) {
        if (key) {
          currentState.availableOptions[key].selected = !currentState.availableOptions[key].selected;
        } else {
          currentState.availableOptionKeys.map( mapKey => {
            currentState.availableOptions[mapKey].selected = false;
          });
        }
      } else {
        var count = 0;
        currentState.availableOptionKeys.map( mapKey => {
          if (currentState.availableOptions[mapKey].selected) {
            count += 1;
          }
        });
        currentState.availableOptionKeys.map( mapKey => {
          if (mapKey == key &&
            (!currentState.availableOptions[mapKey].selected || count > 1)) {
            currentState.availableOptions[mapKey].selected = true;
          } else {
            currentState.availableOptions[mapKey].selected = false;
          }
        });
      }

      if (window.innerWidth < 1020) {
        this.filterChanged = true;
      } else {
        radio("filterChanged").broadcast(this.props.filterKey, this.serializeFilter(currentState));
      }

      return currentState;
    })
  }

  /**
   * Serializes filter to enum string encoding used in path variables
   * @param state Current Component State
   * @returns {unknown[]}
   */
  serializeFilter(state) {
    return state.availableOptionKeys.map ( key => {
      const hasOverrideValue = "enum_value" in state.availableOptions[key];
      const isSelected = state.availableOptions[key].selected

      if(hasOverrideValue) {
        return isSelected ? state.availableOptions[key].enum_value : null;
      } else {
        return isSelected ? key : null;
      }
    }).filter(Boolean);
  }

  getOptionButtonClass(key=null) {
    var className = "option-button";
    if ((key && this.isSelected(key)) || (!key && this.isNoneSelected())) {
      className = className + " " + "selected-option-button";
    }

    return className;
  }

  getOptionButton(key=null) {
    return <div className={this.getOptionButtonClass(key)}>
      <button></button>
    </div>
  }

  searchBoxTextChanged(event) {
    this.setState({
      "searchString": event.target.value
    })

    this.pageNumber = 0;

    this.loadAvailableOptions(null);
  }

  getSearchbox() {
    if (this.props.searchable) {
      return <div
        className="search-box"
        onMouseDown={this.mouseDownHandler.bind(this)}
        onMouseUp={this.mouseUpHandler.bind(this)}
      >
        <input className="form-control" placeholder={this.props.placeholder} value={this.state.searchString} onChange={this.searchBoxTextChanged.bind(this)} onKeyUp={this.searchBoxTextChanged.bind(this)}></input>
      </div>
    } else {
      return
    }
  }

  loadMore() {
    this.pageNumber += 1;

    this.loadAvailableOptions(null);
  }

  getDropdownContent() {
    return <div className="options-container" ref="dropdown">
      {
        this.state.availableOptionKeys.map( key => {
          var availableOption = this.state.availableOptions[key];
          var optionClass = "option";
          if (this.state.availableOptionKeys.indexOf(key) == this.state.availableOptionKeys.length - 1) {
            optionClass = optionClass + " last-option";
          }

          return <div
            className={optionClass}
            onClick={this.optionSelectionChanged.bind(this, key)}
            key={key}
          >
            <waffle.misc.If test={availableOption.icon}>
              <i className={`icon-${availableOption.icon}`}></i>
            </waffle.misc.If>
            <div className="text-block selectable">
              <div className="title">{availableOption.title}</div>
              <waffle.misc.If test={availableOption.subtext}>
                <div className="subtext">{availableOption.subtext}</div>
              </waffle.misc.If>
            </div>
            {this.getOptionButton(key)}
          </div>
        })
      }
      <waffle.misc.If test={this.state.showLoadMore}>
        <div
          className="load-more"
          onClick={this.loadMore.bind(this)}
        >
          <i className="icon-loop-1">Load more...</i>
        </div>
      </waffle.misc.If>
    </div>
  }

  getErrorContent() {
    if (this.state.error) {
      return <div className="alert alert-danger" onClick={this.retry.bind(this)}>
        There was an error fetching results, click to retry
      </div>
    } else {
      return
    }
  }

  retry() {
    this.loadAvailableOptions(null);
  }

  getFilterBoxIcon() {
    return "icon-arrow-65"
  }

  getDropdownClassName() {
    var className = "dropdown unselectable";
    if (!this.state.toggled) {
      className += " hidden";
    }
    if (this.props.showLeft) {
      className += " left-dropdown";
    }

    return className
  }

  multipleSelectChanged() {
    this.setState({
      multiSelectEnabled: !this.state.multiSelectEnabled
    });
  }

  getDropdown() {
    return <div className={this.getDropdownClassName()}>
      <div className="all-content">
        <div className="close-button" onClick={this.toggle.bind(this)}>
          <i className="icon-cross"></i>
        </div>
        {this.getSearchbox()}
        {this.getErrorContent()}
        {this.getDropdownContent()}
      </div>
      <div className="options-footer">
        <div className="option empty-option" onClick={this.optionSelectionChanged.bind(this, null)}>
          {this.getOptionButton()}
          <div className="text-block">
            <div className="title">{this.props.emptySelectedString}</div>
          </div>
        </div>
        {
          this.props.allowSelectMultiple ? (
            <div className="option multiple-select">
              <div className="text-block">
                <div className="title">Select multiple</div>
              </div>
              <div className="inline-div">
                <waffle.misc.OnOffSwitch
                  onChange={this.multipleSelectChanged.bind(this)}
                  checked={this.state.multiSelectEnabled}
                />
              </div>
            </div>
          ) : null
        }
      </div>
      <div className="done-button" onClick={this.toggle.bind(this)}>
        Done
      </div>
    </div>
  }

  getFilterColumns() {
    if (this.props.filterColumns) {
      return this.props.filterColumns
    } else {
      return 2;
    }
  }

  getFilterClass() {
    var baseClass = "filter unselectable col-xs-12 col-md-" + this.getFilterColumns();
    if (this.state.toggled) {
      baseClass += " toggled-filter";
    }
    if (this.props.hidden) {
      baseClass += " hidden";
    }


    return baseClass
  }

  getFilterIcon() {
    if (this.props.filterIcon) {
      return this.props.filterIcon;
    } else {
      return null;
    }
  }

  render() {
    var selectedClass = this.state.toggled ? "selected toggled" : "selected";
    return <div className={this.getFilterClass()} onMouseDown={this.mouseDownHandler.bind(this)} onMouseUp={this.mouseUpHandler.bind(this)}>
      <div className={selectedClass}>
        <div className="clickable-container" onClick={this.toggle.bind(this)}>
          { this.props.filterIcon ? <i className={`${this.props.filterIcon} left-float`} /> : <span style={{float: 'left'}}>&nbsp;</span>}
          <i className={this.getFilterBoxIcon()}></i>
          <div className="selected-container">
            <a>{this.getSelectedString()}</a>
          </div>
        </div>
        {this.getDropdown()}
      </div>
    </div>
  }

  toggle() {
    if (!this.state.toggled) {
      radio("filterShown").broadcast(this);
    }
    if (this.filterChanged) {
      radio("filterChanged").broadcast(this.props.filterKey, this.serializeFilter(this.state));
      this.filterChanged = false;
    }

    this.setState({
      toggled: !this.state.toggled
    });
  }
}
